(function () {
  'use strict';

  document.querySelectorAll('[data-product-list-recommendations]').forEach(function (section) {
    var productId = section.dataset.productId;
    var limit = parseInt(section.dataset.limit, 10) || 4;
    var moneyFormat = section.dataset.moneyFormat || '₹ {{amount}}';
    var container = section.querySelector('[data-recommendations-container]');

    if (!productId || !container) return;

    var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit;

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        // Remove skeleton preloaders
        container.querySelectorAll('[data-skeleton]').forEach(function (el) { el.remove(); });

        if (!data.products || data.products.length === 0) {
          section.style.display = 'none';
          return;
        }

        var html = '';
        data.products.forEach(function (product) {
          var image = product.featured_image
            ? '<img src="' + product.featured_image + '&width=800" alt="' + escapeHtml(product.title) + '" loading="lazy" width="627" height="700">'
            : '<div style="width:100%;height:100%;background:#f5f5f5;"></div>';

          var badge = product.metafields && product.metafields.custom && product.metafields.custom.badge
            ? '<span class="product-list__badge">' + escapeHtml(product.metafields.custom.badge) + '</span>'
            : '';

          var priceHtml = formatMoney(product.price);
          if (product.compare_at_price && product.compare_at_price > product.price) {
            priceHtml += '<span class="product-list__compare-price">' + formatMoney(product.compare_at_price) + '</span>';
            var discountPct = Math.round((product.compare_at_price - product.price) / product.compare_at_price * 100);
            priceHtml += '<span class="product-list__discount">(' + discountPct + '% OFF)</span>';
          }

          html += '<a class="product-list__card" href="' + product.url + '">'
            + '<div class="product-list__img-wrap">'
            + badge
            + '<svg class="product-list__wishlist" viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg">'
            + '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>'
            + '</svg>'
            + image
            + '</div>'
            + '<div class="product-list__info">'
            + '<span class="product-list__name">' + escapeHtml(product.title) + '</span>'
            + '<span class="product-list__price">' + priceHtml + '</span>'
            + '</div>'
            + '</a>';
        });

        container.innerHTML = html;
      })
      .catch(function () {
        container.querySelectorAll('[data-skeleton]').forEach(function (el) { el.remove(); });
        section.style.display = 'none';
      });
  });

  function formatMoney(cents) {
    /* India format: rupee sign, lakh/crore grouping, no decimals (e.g. ₹1,49,700) */
    var r = Math.round((cents || 0) / 100);
    var str = String(Math.abs(r));
    if (str.length > 3) str = str.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + str.slice(-3);
    return (r < 0 ? '-' : '') + '\u20B9' + str;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
})();
